import { axiosClient } from '@services/clients'

export async function getSites() {
  try {
    const {
      data: { result },
    } = await axiosClient('/sites')
    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}
